import apiRoutes from "../../../../../service/apiRoutes";
import api from "../../../../../service/api";

export const createClient = (data) => api.post(apiRoutes.createClient, data)